import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politicas-de-cookies',
  templateUrl: './politicas-de-cookies.component.html',
  styleUrls: ['./politicas-de-cookies.component.scss']
})
export class PoliticasDeCookiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
